import { ReleaseNoteSectionViewOf } from 'bff';
import { InlineText } from '../RichText';

// A screenshot at its own size, never wider than the column, with the caption
// as wide as the image.
export const ImageSection = ({
  section: { content },
}: {
  section: ReleaseNoteSectionViewOf<'image'>;
}) => (
  <div className='mx-auto grid w-fit max-w-full'>
    <img
      src={content.src}
      alt={content.alt}
      className='h-auto max-w-full rounded border border-stone-200 bg-white'
    />
    {content.caption && (
      <p className='mt-2.5 w-0 min-w-full text-[0.8125rem] leading-[1.45] text-stone-600'>
        <InlineText text={content.caption} />
      </p>
    )}
  </div>
);
